import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusTocHeaderHeadline], campus-toc-header-headline',
})
export class TocHeaderHeadlineDirective {
  @HostBinding('class')
  defaultClasses = ['headline-medium', 'text-opacity-high'];
}
